import request from '@/utils/request'

//  登录
export const login = data => request({
    url: '/api/v1/account/login',
    method: 'post',
    data
})

//  注册
export const register = data => request({
    url: '/api/v1/account/register',
    method: 'post',
    data
})

//  发送邮箱验证码
export const sendEmail = data => request({
    url: '/api/v1/sendEmail',
    method: 'post',
    data
})

//  获取aws S3授权
export const awsS3Auth = data => request({
    url: '/api/v1/init/awsS3Auth',
    method: 'post',
    data
})

//  首页
export const home = data => request({
    url: '/api/v1/dashboard/home',
    method: 'post',
    data
})

//  获取用户信息
export const getUserInfo = data => request({
    url: '/api/v1/account/getUserInfo',
    method: 'post',
    data
})

//  修改用户名 / 头像
export const modify = data => request({
    url: '/api/v1/account/modify',
    method: 'post',
    data
})

//  修改登录密码
export const modifyLoginPassword = data => request({
    url: '/api/v1/account/modifyLoginPassword',
    method: 'post',
    data
})

//  忘记登录密码
export const forgetLoginPassword = data => request({
    url: '/api/v1/account/forgetLoginPassword',
    method: 'post',
    data
})

//  认证
export const approve = data => request({
    url: '/api/v1/account/approve',
    method: 'post',
    data
})

// 获取KYC详情
export const getKycInfo = data => request({
    url: '/api/v1/account/kyc/getKycInfo',
    method: 'post',
    data
})

// Corporate FI 保存
export const kyc_corporate = data => request({
    url: '/api/v1/account/kyc/corporate',
    method: 'post',
    data
})

// Company information 保存
export const kyc_company = data => request({
    url: '/api/v1/account/kyc/company',
    method: 'post',
    data
})

// Ownership/controller/shareholder information 保存
export const kyc_shareholder = data => request({
    url: '/api/v1/account/kyc/shareholder',
    method: 'post',
    data
})

// Trading authorization form 保存
export const kyc_trading = data => request({
    url: '/api/v1/account/kyc/trading',
    method: 'post',
    data
})

// KYC 提交审核
export const kyc_all_submit = data => request({
    url: '/api/v1/account/kyc/submit',
    method: 'post',
    data
})

// 联系客服发送消息
export const kyc_submit = data => request({
    url: '/api/v1/feedback/submit',
    method: 'post',
    data
})

// 退出登录
export const exitLogin = data => request({
    url: '/api/v1/account/exitLogin',
    method: 'post',
    data
})

// 充值 详情
export const details = data => request({
    url: '/api/v1/deposit/details',
    method: 'post',
    data
})

// 充值 记录
export const record = data => request({
    url: '/api/v1/deposit/record',
    method: 'post',
    data
})

// 充值 单个 记录详情
export const get = data => request({
    url: '/api/v1/deposit/get',
    method: 'post',
    data
})

// 法币 提币 交易记录
export const fiat_record = data => request({
    url: '/api/v1/withdraw/fiat/record',
    method: 'post',
    data
})

// 法币 提币 交易记录 详情
export const fiat_get = data => request({
    url: '/api/v1/withdraw/fiat/get',
    method: 'post',
    data
})

// 加密货币 提币 交易记录
export const crypto_record = data => request({
    url: '/api/v1/withdraw/crypto/record',
    method: 'post',
    data
})

// 加密货币 提币 交易记录 详情
export const crypto_get = data => request({
    url: '/api/v1/withdraw/crypto/get',
    method: 'post',
    data
})

// 充值 记录下载
export const deposit_download = data => request({
    url: '/api/v1/deposit/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 提币 详情
export const withdraw_details = data => request({
    url: '/api/v1/withdraw/details',
    method: 'post',
    data
})

// 法币 提币 交易记录 下载
export const fiat_download = data => request({
    url: '/api/v1/withdraw/fiat/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 加密货币 提币 交易记录 下载
export const crypto_download = data => request({
    url: '/api/v1/withdraw/crypto/download',
    method: 'post',
    responseType: 'blob',
    data
})

//  加密货币 提币 收款地址 列表
export const crypto_addressList = data => request({
    url: '/api/v1/withdraw/crypto/addressList',
    method: 'post',
    data
})

//  收款地址 新加
export const withdraw_address_add = data => request({
    url: '/api/v1/withdraw/address/add',
    method: 'post',
    data
})

//  收款地址 编辑
export const withdraw_address_edit = data => request({
    url: '/api/v1/withdraw/address/edit',
    method: 'post',
    data
})

//  收款地址 删除
export const withdraw_address_del = data => request({
    url: '/api/v1/withdraw/address/del',
    method: 'post',
    data
})

//  加密货币 提币
export const withdraw_crypto_withdraw = data => request({
    url: '/api/v1/withdraw/crypto/withdraw',
    method: 'post',
    data
})

//  收款地址 列表
export const withdraw_address_list = data => request({
    url: '/api/v1/withdraw/address/list',
    method: 'post',
    data
})

// (法币)  收款人 列表
export const withdraw_payee_list = data => request({
    url: '/api/v1/withdraw/payee/list',
    method: 'post',
    data
})

// (法币)  收款人 新加
export const withdraw_payee_add = data => request({
    url: '/api/v1/withdraw/payee/add',
    method: 'post',
    data
})

// (法币)  收款人 编辑
export const withdraw_payee_edit = data => request({
    url: '/api/v1/withdraw/payee/edit',
    method: 'post',
    data
})

// (法币)  收款人 删除
export const withdraw_payee_del = data => request({
    url: '/api/v1/withdraw/payee/del',
    method: 'post',
    data
})

// (法币)  法币 - 提币
export const withdraw_fiat_withdraw = data => request({
    url: '/api/v1/withdraw/fiat/withdraw',
    method: 'post',
    data
})

// 加密货币 提币 收款地址 检测
export const withdraw_crypto_check = data => request({
    url: '/api/v1/withdraw/crypto/check',
    method: 'post',
    data
})

// 交易记录
export const transaction_record = data => request({
    url: '/api/v1/transaction/record',
    method: 'post',
    data
})

// 交易记录下载
export const transaction_download = data => request({
    url: '/api/v1/transaction/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 交易记录详情
export const transaction_get = data => request({
    url: '/api/v1/transaction/get',
    method: 'post',
    data
})

// 申请信用卡 - director信息列表
export const getDirectorList = data => request({
    url: '/api/v1/card/getDirectorList',
    method: 'post',
    data
})

// 申请信用卡
export const card_submit = data => request({
    url: '/api/v1/card/submit',
    method: 'post',
    data
})

// 申请记录
export const card_record = data => request({
    url: '/api/v1/card/record',
    method: 'post',
    data
})

// 申请信用卡 - 获取FEB Debit Card 配置
export const card_getConfig = data => request({
    url: '/api/v1/card/getConfig',
    method: 'post',
    data
})

// 申请信用卡 - 链接
export const linkSubmit_str = data => request({
    url: '/api/v1/card/linkSubmit',
    method: 'post',
    data
})

// 申请记录 -详情
export const card_get = data => request({
    url: '/api/v1/card/get',
    method: 'post',
    data
})

// 申请记录 - 审核
export const card_audit = data => request({
    url: '/api/v1/card/audit',
    method: 'post',
    data
})

// 申请记录 - 激活
export const card_active = data => request({
    url: '/api/v1/card/active',
    method: 'post',
    data
})

// 申请记录 - 获取充值配置
export const card_getTopUpConfig = data => request({
    url: '/api/v1/card/getTopUpConfig',
    method: 'post',
    data
})

// 申请记录 - 充值
export const card_topUp = data => request({
    url: '/api/v1/card/topUp',
    method: 'post',
    data
})

// 申请记录 - 充值记录
export const card_topRecord = data => request({
    url: '/api/v1/card/topRecord',
    method: 'post',
    data
})

// 申请记录 - 充值记录下载
export const card_download = data => request({
    url: '/api/v1/card/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 申请记录 - 刷新余额
export const refreshData = data => request({
    url: '/api/v1/card/refreshData',
    method: 'post',
    data
})

// 充值 - 法币充值 submit
export const deposit_submit = data => request({
    url: '/api/v1/deposit/submit',
    method: 'post',
    data
})

// 修改卡密码
export const setPin = data => request({
    url: '/api/v1/card/setPin',
    method: 'post',
    data
})

// 获取卡的交易记录
export const transactionDetails = data => request({
    url: '/api/v1/card/transactionDetails',
    method: 'post',
    data
})

// 获取卡的交易记录 - 下载
export const transactionDownload = data => request({
    url: '/api/v1/card/transactionDownload',
    method: 'post',
    responseType: 'blob',
    data
})

// 充值 - 法币充值 获取配置
export const deposit_getConfig = data => request({
    url: '/api/v1/deposit/getConfig',
    method: 'post',
    data
})

// 加密货币 提币 - 计算手续费 以及到账数量
export const crypto_calc = data => request({
    url: '/api/v1/withdraw/crypto/calc',
    method: 'post',
    data
})

// 申请记录 - 充值 - 计算
export const card_calc = data => request({
    url: '/api/v1/card/calc',
    method: 'post',
    data
})

// my transaction USDT USDC 余额
export const transaction_details = data => request({
    url: '/api/v1/transaction/details',
    method: 'post',
    data
})

// 首页 - 账户结单
export const accountStatement = data => request({
    url: '/api/v1/dashboard/accountStatement',
    method: 'post',
    data
})

// 首页 - 账户明细
export const accountDetails = data => request({
    url: '/api/v1/dashboard/accountDetails',
    method: 'post',
    data
})

// 交易记录 - 账户明细
export const statsment = data => request({
    url: '/api/v1/transaction/statsment',
    method: 'post',
    data
})

// 交易记录 - 详情账单
export const detailsStatement = data => request({
    url: '/api/v1/transaction/detailsStatement',
    method: 'post',
    data
})

// 合同不同级别可下单数量 统计
export const getLeftAmount = data => request({
    url: '/api/v1/contract/getLeftAmount',
    method: 'post',
    data
})

// 合同列表
export const contractList = data => request({
    url: '/api/v1/contract/contractList',
    method: 'post',
    data
})

// 创建合同订单 只有合同状态为1 可以创建订单
export const createOrder = data => request({
    url: '/api/v1/contract/createOrder',
    method: 'post',
    data
})

// 合同订单列表
export const orderList = data => request({
    url: '/api/v1/contract/orderList',
    method: 'post',
    data
})

// 取消订单 只有订单状态为1可以取消订单
export const cancelOrders = data => request({
    url: '/api/v1/contract/cancelOrders',
    method: 'post',
    data
})

// 订单发卡记录列表
export const orderCardList = data => request({
    url: '/api/v1/contract/orderCardList',
    method: 'post',
    data
})

// 卡管理列表
export const cardList = data => request({
    url: '/api/v1/contract/cardList',
    method: 'post',
    data
})

// 订单列表
export const orderListByCardInfo = data => request({
    url: '/api/v1/contract/orderListByCardInfo',
    method: 'post',
    data
})

// 未分配卡列表
export const unassignedList = data => request({
    url: '/api/v1/preallocation/unassignedList',
    method: 'post',
    data
})

// 绑定卡
export const preallocation_bind = data => request({
    url: '/api/v1/preallocation/bind',
    method: 'post',
    data
})

// 解绑卡
export const preallocation_unbind = data => request({
    url: '/api/v1/preallocation/unbind',
    method: 'post',
    data
})

// card -详情
export const getCardKyc = data => request({
    url: '/api/v1/card/getCardKyc',
    method: 'post',
    data
})

// 合同 - 详情
export const getContract = data => request({
    url: '/api/v1/contract/getContract',
    method: 'post',
    data
})

// 子账号列表
export const childList = data => request({
    url: '/api/v1/account/childList',
    method: 'post',
    data
})

// 封卡 冻结
export const block = data => request({
    url: '/api/v1/preallocation/block',
    method: 'post',
    data
})

// 解封
export const unblock = data => request({
    url: '/api/v1/preallocation/unblock',
    method: 'post',
    data
})

// 申请信用卡-验证邮箱
export const verifyCode = data => request({
    url: '/api/v1/card/verifyCode',
    method: 'post',
    data
})

// 申请信用卡-验证用户名
export const verifyUsername = data => request({
    url: '/api/v1/card/verifyUsername',
    method: 'post',
    data
})

// 设置更新 公司简称
export const modifyCompanyAbbreviation = data => request({
    url: '/api/v1/account/modifyCompanyAbbreviation',
    method: 'post',
    data
})

// 用户kyc列表
export const accountKycList = data => request({
    url: '/api/v1/card/accountKycList',
    method: 'post',
    data
})

// 更新用户ID kyc信息
export const updateIdKycInfo = data => request({
    url: '/api/v1/card/updateIdKycInfo',
    method: 'post',
    data
})

// 更新用户信息
export const updateAccountInfo = data => request({
    url: '/api/v1/card/updateAccountInfo',
    method: 'post',
    data
})

// 更新地址信息
export const updateAddressKycInfo = data => request({
    url: '/api/v1/card/updateAddressKycInfo',
    method: 'post',
    data
})

// card -详情
export const card_details = data => request({
    url: '/api/v1/card/getCardKyc',
    method: 'post',
    data
})

// 修改运营状态
export const modifyOpStatus = data => request({
    url: '/api/v1/card/modifyOpStatus',
    method: 'post',
    data
})

// 申请信用卡 - 链接 ruiying
export const linkSubmit_ruiying = data => request({
    url: '/api/v1/card/linkSubmitRuiying',
    method: 'post',
    data
})

// 数量统计
export const statistics = data => request({
    url: '/api/v1/contract/statistics',
    method: 'post',
    data
})

// 可用卡级别列表
export const levelList = data => request({
    url: '/api/v1/contract/levelList',
    method: 'post',
    data
})

// 获取配置数据传参数ID,页面显示name
export const getConfigData = data => request({
    url: '/api/v1/contract/getConfigData',
    method: 'post',
    data
})

// 修改webhook
export const modifyWebhookApi = data => request({
    url: '/api/v1/account/modifyWebhookApi',
    method: 'post',
    data
})

// 卡管理列表-下载
export const cardListDownload = data => request({
    url: '/api/v1/contract/cardListDownload',
    method: 'post',
    responseType: 'blob',
    data
})

// ruiying - 链接
export const linkSubmitQr = data => request({
    url: '/api/v1/card/linkSubmitQr',
    method: 'post',
    data
})

// 申请信用卡-验证kitnumber以及确认码
export const verifyKitNumber = data => request({
    url: '/api/v1/card/verifyKitNumber',
    method: 'post',
    data
})

// 用户kyc列表-下载
export const accountKycListDownload = data => request({
    url: '/api/v1/card/accountKycListDownload',
    method: 'post',
    responseType: 'blob',
    data
})

// 更新用户信息
export const updateMemberInfo = data => request({
    url: '/api/v1/card/updateMemberInfo',
    method: 'post',
    data
})

// 年费记录列表
export const annualFee_record = data => request({
    url: '/api/v1/annualFee/record',
    method: 'post',
    data
})

// 年费记录列表-view查看详情
export const annualFee_details = data => request({
    url: '/api/v1/annualFee/details',
    method: 'post',
    data
})

// 年费记录列表-添加备注
export const annualFee_remark = data => request({
    url: '/api/v1/annualFee/remark',
    method: 'post',
    data
})

// 年费记录列表-修改付款模式
export const annualFee_modify = data => request({
    url: '/api/v1/annualFee/modify',
    method: 'post',
    data
})

// 年费记录列表-下载
export const annualFee_download = data => request({
    url: '/api/v1/annualFee/download',
    method: 'post',
    responseType: 'blob',
    data
})

// 获取申请页面参数
export const getLinkParamByPath = data => request({
    url: '/api/v1/card/getLinkParamByPath',
    method: 'post',
    data
})

// 年费记录列表-刷新卡余额
export const refresh = data => request({
    url: '/api/v1/annualFee/refresh',
    method: 'post',
    data
})

// 登录验证谷歌令牌
export const account_verify = data => request({
    url: '/api/v1/account/verify',
    method: 'post',
    data
})

// 修改登录email
export const modifyLoginEmail = data => request({
    url: '/api/v1/account/modifyLoginEmail',
    method: 'post',
    data
})
